/* eslint-disable */
import * as url from "helper/UrlHelper";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import downloadFileHandler from "helper/DownloadFile";

import React from "react";

const EventDetailsView = ({
  eventData,
  memberStatus,
  t,
  joinEventHandler = () => {},
  isJoining = false,
}) => {
  return (
    <div className="mt-3 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
      <div
        className={`details_info_heading d-flex align-items-center justify-content-between ${
          memberStatus.status === "1" ? "mb-4" : ""
        }`}
      >
        <h2 className="fw-bold mb-0 text-black">{eventData.title}</h2>

        {memberStatus.status === "1" && memberStatus.modStatus === "1" ? (
          <div className="d-flex justify-content-end">
            {memberStatus.joinDate ? (
              <p className="fs-md mb-0 text-black">
                {t("Joined date")} -{" "}
                {getDateFormatInSpanish(memberStatus.joinDate)}
              </p>
            ) : null}
          </div>
        ) : (
          <button
            onClick={joinEventHandler}
            className="btn btn-primary"
            disabled={isJoining ? true : false}
            style={{
              cursor: isJoining ? "not-allowed" : "pointer",
            }}
          >
            {t("Accept Invite")}
            {isJoining && (
              <div
                className="mx-2 spinner-border spinner-border-sm"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </button>
        )}
      </div>

      {memberStatus.status !== "1" && memberStatus.inviteDate && (
        <div className="d-flex justify-content-end mt-1 mb-4">
          <p className="fs-md mb-0 text-black">
            {t("Invitation sent on")} -{" "}
            {getDateFormatInSpanish(memberStatus.inviteDate)}
          </p>
        </div>
      )}

      {eventData.image && (
        <ul className="preview-uploaded-files d-flex flex-wrap gap-2 mb-4 mt-2">
          <li className="file border border-gray rounded-8 overflow-hidden position-relative">
            <img
              src={
                eventData.image == ""
                  ? "https://placehold.co/150x150"
                  : url.SERVER_URL + eventData.image
              }
              alt="Uploaded"
              className="w-100 h-100 object-fit-cover object-center"
            />
          </li>
        </ul>
      )}

      {eventData.summary && (
        <div className="descriptiion_bx mb-4">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Summary")}</h4>
          <p className="mb-4 text-black fs-md">{eventData.summary}</p>
        </div>
      )}

      {eventData.description && (
        <div className="descriptiion_bx mb-4">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Description")}</h4>
          <div
            className="mb-4 text-black fs-md"
            dangerouslySetInnerHTML={{ __html: eventData.description }}
          />
        </div>
      )}

      <div className="info_date_outer d-flex flex-wrap gap-2 mt-4">
        <div className="info_date_bx body-bg rounded-10 px-3 py-2">
          <label className="mb-1 fs-sm text-black fw-regular">
            {t("Start Date")}
          </label>
          <h5 className="mb-0 text-black fs-sm fw-semibold">
            {getDateFormatInSpanish(eventData.startDate)}
          </h5>
        </div>
        <div className="info_date_bx body-bg rounded-10 px-3 py-2">
          <label className="mb-1 fs-sm text-black fw-regular">
            {t("End Date")}
          </label>
          <h5 className="mb-0 text-black fs-sm fw-semibold">
            {getDateFormatInSpanish(eventData.endDate)}
          </h5>
        </div>
      </div>

      {eventData.documents.length > 0 && (
        <div className="documents mt-4">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Documents")}</h4>
          <div className="d-flex flex-wrap gap-2 mt-3">
            {eventData.documents.map((file, index) => (
              <div
                key={index}
                className="d-flex align-items-center px-3 py-2 border border-gray rounded-3"
              >
                <p className="fw-medium mb-0 me-2">{file.name}</p>
                <button onClick={() => downloadFileHandler(file)}>
                  <span className="material-symbols-outlined">download</span>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EventDetailsView;
